// React
// Helpers
import React from 'react';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import { isEmpty } from 'lodash';
import { MainLayout } from 'src/features';
import EmptyList from 'src/features/question-list/empty-list';
import { useQuestions } from 'src/services';
import { withRedux } from '@utils';
import { wrapper } from '@store';

// Third Party Modules
// Store

type Props = {
  data: any;
};
const QuestionListByMonth = dynamic(() => import('../../src/features/question-list/question-list-by-month'));

// Home
const Engine = ({ data }: Props) => {
  return (
    <>
      {/* <NextSeo
        title={`${data?.title} - ${process.env.NEXT_PUBLIC_SITENAME}`}
        description={process.env.NEXT_PUBLIC_DESCRIPTION}
        canonical={String(window?.location)}
        openGraph={{
          type: 'website',
          url: String(window?.location),
          site_name: process.env.NEXT_PUBLIC_SITENAME,
          title: data?.title,
          description: data?.title,
          images: [{ url: `${process.env.NEXT_PUBLIC_HOST}/images/common/og-default.png` }],
        }}
      /> */}
      <MainLayout title={data?.title}>{isEmpty(data?.list) ? <EmptyList /> : <QuestionListByMonth data={data?.list} type="araç tekniği" />}</MainLayout>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  withRedux(
    async () => {
      const { getMonthsByType } = useQuestions();

      const [data] = await Promise.all([(await getMonthsByType('arac-teknigi')).data]);
      return { props: { data } };
    },
    { store },
  ),
);

export default Engine;
